

import './AboutUs.css';

function AboutUs() {
  return (
    <div className="about-page">

      <section className="about-hero">
        <div className="about-hero-content">
          <h1>About CarbCareUSA</h1>
          <p>
            CarbCareUSA is dedicated to preserving, restoring, and upgrading carburetor systems
            for classic cars, marine engines, hot rods, and performance builds. Our goal is
            simple: keep mechanical engines alive with the right parts, the right support,
            and the right knowledge.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="about-story-text">
          <h2>Our Mission</h2>
          <p>
            Carburetors are more than parts — they are part of automotive history.
            At CarbCareUSA we focus on sourcing, restoring, and supplying carburetor
            components that keep classic engines running strong.
          </p>
          <p>
            From Rochester and Holley systems to Stromberg classics and marine carburetors,
            our mission is to provide enthusiasts and professionals with reliable
            components and trustworthy technical guidance.
          </p>
        </div>

        <div className="about-story-image">
          <img
            src="/assets/images/about/workshop.jpg"
            alt="Carburetor workshop"
          />
        </div>
      </section>

      <section className="about-values">
        <h2>What We Believe</h2>

        <div className="about-values-grid">

          <div className="about-value-card">
            <h3>Mechanical Heritage</h3>
            <p>
              Classic carburetor systems represent decades of engineering innovation.
              Our work focuses on preserving that legacy.
            </p>
          </div>

          <div className="about-value-card">
            <h3>Precision Parts</h3>
            <p>
              Carburetors demand precision. Every rebuild kit, component, and tool
              must meet strict mechanical tolerances.
            </p>
          </div>

          <div className="about-value-card">
            <h3>Real Support</h3>
            <p>
              Whether you're restoring a marine carburetor or tuning a hot rod,
              our goal is to provide clear guidance and dependable parts.
            </p>
          </div>

        </div>
      </section>

      <section className="about-cta">
        <h2>Explore Our Carburetor Catalog</h2>
        <p>
          Browse our growing catalog of carburetors, rebuild kits, and specialty
          components designed for classic engines.
        </p>

        <a href="/products" className="about-button">
          View Products
        </a>
      </section>

    </div>
  );
}

export default AboutUs;